import LineWinTransitions from "slotworks/integration/revolver/transitions/line-win-transitions";
import gameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import settingsModel from "slotworks/model/settings/settings-model";
import soundManager from "slotworks/sound/sound-manager";

export default class HarleyLineWinTransitions extends LineWinTransitions {

    public out() {
        const noWinWin = settingsModel.isUKJurisdiction() && !gameState.getCurrentGame().isWinAboveBet();
        const record = gameState.getCurrentGame().getCurrentRecord() as SpinRecord;

        if(!noWinWin && record.timesCycled <= 1)
            soundManager.customEvent("tally_collect");

        return super.out();
    }

}